import React from 'react';
import {getDateSlash, getMinute, getTimeHH} from "../../../../utility/DateUtils";
const Waiting = ({nextDraw}) => {
    return (
        <div id="statusbar">
            <a href="/" className="waitting">Đang chờ xổ số Miền Trung lúc {getTimeHH(nextDraw)}h{getMinute(nextDraw)}': {getDateSlash()}</a>
        </div>

    );
};

export default Waiting;
